import { UseQueryOptions } from '@tanstack/react-query';

import { SMS } from 'domains/content/types';
import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';

import QueryKeys from './keys';

/**
 * Hook to fetch all SMS content
 *
 * @param reactQueryOptions Additional react-query options
 * @param axiosOptions Options for axios request (e.g., params for query string)
 * @returns Query result with array of SMS content items
 */
const useSmses = (
    reactQueryOptions?: UseQueryOptions<SMS[], Error>,
    axiosOptions?: { params?: { status?: string } }
) => {
    // Always filter by status=published,live
    const mergedAxiosOptions = {
        ...axiosOptions,
        params: {
            ...axiosOptions?.params,
            status: 'published,live',
        },
    };

    const mergedReactQueryOptions = {
        ...reactQueryOptions,
    };

    return useQuery<SMS[]>(QueryKeys.SMSES, CuredApiPaths.SMS, mergedReactQueryOptions, mergedAxiosOptions);
};

export default useSmses;
